import { gql } from "apollo-boost";

export const GET_BOOKING = gql`
  query consumerGetBooking($bookingId: String!) {
    consumerGetBooking(bookingId: $bookingId) {
      id
      bookingId
      dateStarted
      taxExempted
      pcoNumber
      dateReturned
      bookingCategory
      organisationId
      additionalTnc
      quoteUrl 
      rentalAgreementUrl
      vehicleConditionReportUrls
      quoteUrl
      bookingConfirmationUrl
      zeroCostBooking
      zeroCostBookingNote
      isSubscription
      isRecurringBilling
      isFleetAllocation
      subscriptionInsurance {
        id
      }
      activeSubscription {
        startDate
        endDate
        subscription {
          id
          name
          rateTypeName
          insurancePolicy {
            name
          }
          addons {
            displayName
          }
        }
        vehicle {
          isGhostVehicle
          licencePlate
          make
          model
          vin
          id
          colour
        }
        duration
        subscriptionAmount
        enrollmentAmount
        mileageLimit
        unlimitedMileage
        pricePerExtraMile
        swapsAllowed
      }
      swapRequests {
        id
        isActive
        vehicle {
          id
          licencePlate
        }
        status
        dateForSwap
        createdAt
        events {
          eventTime
          eventBy
          userType
          notes
        }
        vehicleAllocated {
          id
          make
          model
          licencePlate
          imageUrl
          bodyType
          numberOfSeats
          numberOfDoors
          transmission
          fuelType
        }
        vehicle {
          id
          make
          model
          licencePlate
        }
      }
      consumedSwaps {
        swapRequestId
        previousVehicle {
          id
          licencePlate
        }
        newVehicle {
          id
          licencePlate
        }
        swappedOn
      }
      depositDetails {
        amount
        amountAdjusted
        payment {
          id
          status
          paymentMode
          paymentGateway
          dateCreated
          amount
          remainingAmount
        }
        payments {   
          id
          status
          paymentMode
          paymentGateway
          dateCreated
          amount
          remainingAmount
        }
        adjustedCreditNotes {
          amount
          adjustedAt
          creditNote {
            id
            creditNoteRef
          }
        }
        adjustedAgainst {
          id
          invoiceRef
        }
        refund {
          amount
          refundRef
          status
          mode
          currency
          id
          paymentIntent
          paymentId
        }
      }
      lastEventTime
      lastEventType
      lastEventBy {
        id
        firstName
        lastName
        email
      }
      events {
        eventType
        eventTime
        user
        previousEndDate
        newEndDate
      }
      creditNotes {
        id
        creditNoteRef
        creditNoteType
        createdAt
        invoice {
          invoiceRef
          confirmedPaidAmount
        }
        totalAmount
        refundedAmount
        availableAmount
        creditNoteItems {
          type
          description
          originalPrice
          quantity
          unitPrice
          totalAmount
          duration
        }
        refunds {
          mode
          amount
          status
          id
          refundRef
          currency
          paymentIntent
        }
        allocations {
          amount
          allocatedAt
          invoice {
            invoiceRef
          }
        }
      }
      latestExtension {
        extensionNumber
        referenceNumber
        startDate
        endDate
        status
        id
        requestedBy
        conflictingBookingReference
      }
      extensions {
        extensionNumber
        referenceNumber
        startDate
        endDate
        status
        id
        invoice {
          invoiceRef
        }
        dropoffServiceLocation {
          name
        }
      }
      firstInvoice {
        dateCreated
        dateUpdated
        createdBy
        updatedBy
        discount {
          appliedBy
          appliedDate
          isPercent
          code
          amount
        }
        invoiceRef
        status
        locked
        invoiceType
        startDate
        endDate
        tax {
          appliedBy
          appliedDate
          code
          amount
        }
        invoiceItems {
          type
          description
          quantity
          unitPrice
          totalAmount
        }
        dueAmount
        totalPayableAmount
        anyPaidAmount
        confirmedPaidAmount
        anyRefundAmount
        confirmedRefundAmount 
        otherRefunds
        depositRefund
        balanceDueFromPreviousInvoice
        damageAmount
        finesAmount
        valetAmount
        otherCharges {
          amount
          name
        }
        id
        taxAmount
        rentalAmount
        insuranceAmount
        discountAmount
        addonsAmount
        protectionPlanAmount
        rateTypeName
        rateTypeDuration
        payments {
          id
          dateCreated
          lastUpdated
          createdBy
          updatedBy
          note
          paymentMode
          paymentType
          emailNotify
          expireBy
          amount
          currency
          description
          smsNotify
          status
        }
      }
      currentInvoice {
        dateCreated
        dateUpdated
        createdBy
        updatedBy
        discount {
          appliedBy
          appliedDate
          isPercent
          code
          amount
        }
        invoiceRef
        status
        locked
        invoiceType
        startDate
        endDate
        tax {
          appliedBy
          appliedDate
          code
          amount
        }
        invoiceItems {
          type
          description
          quantity
          unitPrice
          totalAmount
        }
        totalPayableAmount
        anyPaidAmount
        confirmedPaidAmount
        anyRefundAmount
        confirmedRefundAmount
        otherRefunds
        depositRefund
        balanceDueFromPreviousInvoice
        damageAmount
        finesAmount
        valetAmount
        otherCharges {
          amount
          name
        }
        id
        taxAmount
        rentalAmount
        insuranceAmount
        discountAmount
        addonsAmount
        rateTypeName
        rateTypeDuration
        payments {
          id
          dateCreated
          lastUpdated
          createdBy
          updatedBy
          note
          paymentMode
          paymentType
          emailNotify
          expireBy
          amount
          currency
          description
          smsNotify
          status
        }
      }
      finalInvoice {
        dateCreated
        dateUpdated
        createdBy
        updatedBy
        discount {
          appliedBy
          appliedDate
          isPercent
          code
          amount
        }
        invoiceRef
        status
        locked
        invoiceType
        startDate
        endDate
        tax {
          appliedBy
          appliedDate
          code
          amount
        }
        invoiceItems {
          type
          description
          quantity
          unitPrice
          totalAmount
        }
        totalPayableAmount
        anyPaidAmount
        confirmedPaidAmount
        anyRefundAmount
        confirmedRefundAmount
        otherRefunds
        depositRefund
        balanceDueFromPreviousInvoice
        damageAmount
        finesAmount
        valetAmount
        otherCharges {
          amount
          name
        }
        id
        payments {
          id
          dateCreated
          lastUpdated
          createdBy
          updatedBy
          note
          paymentMode
          paymentType
          emailNotify
          expireBy
          amount
          currency
          description
          smsNotify
          status
        }
      }
      referenceNumber
      dateCreated
      dateUpdated
      createdBy {
        id
        firstName
        lastName
      }
      updatedBy {
        id
        firstName
        lastName
      }
      pickupServiceLocation {
        id
        name
        address {
          street
          city
          state
          country
          zipcode
          fullAddress
        }
      }
      pickupOtherLocation {
        street
        city
        state
        country
        zipcode
        fullAddress
        location {
          type
          latitude
          longitude
        }
      }
      pickupDateTime
      dropoffServiceLocation {
        id
        name
        address {
          street
          city
          state
          country
          zipcode
          fullAddress
        }
      }
      dropoffOtherLocation {
        street
        city
        state
        country
        zipcode
        fullAddress
        location {
          type
          latitude
          longitude
        }
      }
      dropoffDateTime
      extendedDropoffDateTime
      initialDropoffDateTime
      longTermBooking
      flightNumber
      insuranceRate
      insurancePercentageRate
      excess
      customerType
      discount {
        appliedBy
        appliedDate
        isPercent
        code
        amount
      }
      appliedOffers {
        offerId
        offerName
        code
        discountAmount
      }
      tax {
        appliedBy
        appliedDate
        code
        amount
        payableAmount
        type
        rate
        isVehicleGroupSpecific
        vehicleGroups
        subdivisionOptIn
        subdivisionValue
        subdivisionType
        subdivisionRate
      }
      invoices {
        dateCreated
        dateUpdated
        createdBy
        updatedBy
        discount {
          appliedBy
          appliedDate
          isPercent
          code
          amount
        }
        invoiceRef
        status
        locked
        invoiceType
        startDate
        endDate
        tax {
          appliedBy
          appliedDate
          code
          amount
        }
        invoiceItems {
          type
          description
          quantity
          unitPrice
          totalAmount
        }
        totalPayableAmount
        anyPaidAmount
        confirmedPaidAmount
        anyRefundAmount
        confirmedRefundAmount
        otherRefunds
        depositRefund
        balanceDueFromPreviousInvoice
        damageAmount
        finesAmount
        valetAmount
        otherCharges {
          amount
          name
        }
        id
        taxAmount
        rentalAmount
        insuranceAmount
        discountAmount
        addonsAmount
        rateTypeName
        rateTypeDuration
      }
      activeInvoices {
        id
        dateCreated
        invoiceRef
        status
        startDate
        endDate
        invoiceType
        totalPayableAmount
        confirmedPaidAmount
        otherCharges {
          amount
          name
        }
      }
      rateTypeName
      rateTypeDuration
      billingCycleName
      billingCycleDuration
      billingFrequency
      status
      cancellationReason
      addonRequirements {
        addon {
          id
          name
          category
          imageUrl
          hasFixedRate
          hasQuantity
          fixedRate
          description
          displayName
          recurringRate {
            rateTypeName
            rateTypeDuration
            rate
            longTerm
          }
          totalQuantity
          availableQuantity
          isActivated
        }
        rate
        quantity
        name
        hasFixedRate
        displayName
        payableAmount
        tax {
          title
          value
        }
        isSubscriptionIncluded
      }
      customer {
        id
        firstName
        lastName
        email
        nationalInsuranceNumber
        phoneNumber {
          phone
          country
        }
        dateOfBirth
        customerPCONumber
        location {
          street
          city
          state
          country
          zipcode
          fullAddress
        }
        license {
          dateOfExpiry
          licenseNumber
          authority
        }
      }
      currentBookingSchedules {
        id
        startDate
        endDate
        status
        vehicleStatus
        linkedActions {
          id
          category
          jobLinked {
            id
            status
            subCategory
            lastKnownDriverLocation {
              id
              latitude
              longitude
              timestamp
            }
            address {
              dropOffAddress {
                geometry{
                  latitude
                  longitude
                }
              }
            }
          }
        }
        driver {
          id
        }
        vehicle {
          id
          licencePlate
          imageUrl
          pcoNumber
          vin
          make
          model
          features
          activeVehicleDamages {
            id
            damages {
              title
              damageType
              damageKind
              damageArea
              descriptions
              location {
                x
                y
              }
            }
          }
          vehicleState {
            type
            odometerReading
            generalChecks {
              name
              status
              images
            }
            defaultAccesories {
              name
              status
              images
            }
          }
        }
        dropoffCheck {
          customerInfo {
            signature
          }
          vehicleStatePdfUrl
        }
      }
      businessCustomer {
        id
        businessName
        registrationNumber
        VAT
        registeredAddress {
          street
          city
          state
          zipcode
          country
          fullAddress
        }
        tradingAddressSame
        tradingAddress {
          street
          city
          state
          zipcode
          country
          fullAddress
        }
        creditLimitEnabled
        creditLimit
        approvedDrivers {
          id
          status
          firstName
          lastName
          phoneNumber {
            phone
            country
          }
          email
        }
        authorizedSignatories {
          id
          firstName
          lastName
          phoneNumber {
            phone
            country
          }
          email
        }
        billing {
          phoneNumber {
            phone
            country
          }
          email
        }
        contact {
          firstName
          lastName
          phoneNumber {
            phone
            country
          }
          email
        }
        documents {
          id
          name
          title
          documentType
          expiryDate
          url
        }
      }
      authorizedSignatory
      insurancePolicy {
        id
        name
        description
        isPercentage
      }
      paymentDetails {
        rentalAmount
        startDate
        endDate
        taxAmount
        rentalAmount
        insuranceAmount
        discountAmount
        offerDiscountAmount
        addonsAmount
        totalPayableAmount
        rentalTime
        isProrated
        standardBillingDays
        proratedBillingDays
      }
      vehicleGroups {
        activeVehicleSchedules {
          id
          vehicleStatus
          vehicle {
            isGhostVehicle
            id
            licencePlate
            make
            model
            features
            colour
            pcoNumber
            vin
            branch
            branchDetails {
              id
              name
            }
          }
          dropoffCheck {
            vehicleStatePdfUrl
          }
          pickupCheck {
            vehicleStatePdfUrl
          }
          driver {
            id
            note
          }
        }
        vehicleGroup {
          basePrices {
            rateTypeName
            mileageLimit
            unlimitedMileage
          }
          name
          id
        }
        name
        vehicleIds
        baseRate
        priceRuleOperator
        priceRuleValueType
        priceRuleTriggerType
        priceRuleAmount
        priceRuleName
        deposit
        mileageLimit
        pricePerExtraMile
        unlimitedMileage
        count
        riskBasedPricingApplied
        riskBasedPricingAmount
      }
      approvedDrivers {
        id
        status
        firstName
        lastName
        phoneNumber {
          phone
          country
        }
        email
        location {
          street
          state
          country
          fullAddress
        }
        license {
          authority
          licenseNumber
          dateOfExpiry
          images
        }
      }
      notes {
        id
        description
        createdBy {
          id
          firstName
          lastName
        }
        createdDate
      }
      additionalInformation {
        description
      }
      noteFromWebsite {
        description
        createdAt
      }
      preBookingQuestions {
        question
        answer
        answerType
      }
      deliveryQuestions {
        question
        answer
        answerType
      }
      locationSurcharges {
        id
        name
        value
        type
        rate
        tax {
          title
          value
        }
        payableAmount
        payableTaxAmount
      }
      oneWayRentalFee {
        amount
        taxable
        tax {
          title
          type
          value
        }
      }
      source
      poNumber
      smartCarVehicle
      previousBookingSchedules {
        id
        vehicle {
          licencePlate
          make
          model
          vin
        }
        dropoffCheck {
          vehicleStatePdfUrl
        }
        pickupCheck {
          vehicleStatePdfUrl
        }
      }
      vehicleReplacement {
        # vehicleGroups {
        activeVehicleSchedules {
          id
          vehicleStatus
          vehicle {
            isGhostVehicle
            id
            licencePlate
            make
            model
            features
            colour
            pcoNumber
            vin
            branch
            branchDetails {
              id
              name
            }
          }
          dropoffCheck {
            vehicleStatePdfUrl
          }
          pickupCheck {
            vehicleStatePdfUrl
          }
        }
        vehicleGroup {
          basePrices {
            rateTypeName
            mileageLimit
            unlimitedMileage
          }
          name
          id
        }
        vehicleIds
        baseRate
        priceRuleOperator
        priceRuleValueType
        priceRuleTriggerType
        priceRuleAmount
        priceRuleName
        deposit
        mileageLimit
        pricePerExtraMile
        unlimitedMileage
        count
      }
      branchId
      bookingCategory
      branch {
        id
        name
        timeZone
        address {
        street
        city
        state
        country
        zipcode
        fullAddress
        }
      }
      isCoi
      isNonNegotiable
      deliveryAddress {
        street
        city
        state
        country
        zipcode
        fullAddress
        location {
          type
          latitude
          longitude
        }
      }
      bookingCategory
      testDriveBookingDetails {
        experience
        type
      }
      coiDetails {
        documentUrl
        expiryDate
        policyName
        policyNumber
        provider
      }
      protectionPlan {
        plan {
          id
          name
          description
          excess
          code
        }
        name
        taxable
        tax {
          title
          value
        }
        hasFixedRate
        rate
        payableAmount
        taxAmount
      }
      valetSlot {
        deliverySlot {
          slot
          driverId
        }
        collectionSlot {
          slot
          driverId
        }
      }
      projectId
      costCenter
      isKeylessEntry
      riskBasedPricingParams {
        driverAge
        licenceDuration
        penaltyPoints
        insuranceClaimsHistory
      }
    }
  }
`;
